import React, { useState, useEffect } from 'react';

const fmt = (val) => Number(val).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');

const CarritoLateral = ({ carro, setCarro, mostrar, toggleCarro, confirmarCompra, tipoVenta, setTipoVenta, onPersonalizarItem, modoFijo = false, descuentoGlobal = 0 }) => {
    // 🚩 Detectar si es móvil para UI adaptativa
    const [esMobile, setEsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const checkMobile = () => setEsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const subtotal = Math.round(carro.reduce((acc, item) => acc + (Number(item.precio || item.valor || 0) * item.cantidad), 0));
    const ahorro = Math.round(subtotal * (descuentoGlobal / 100));
    const totalFinal = subtotal - ahorro;
    const eliminarDelCarro = (id) => setCarro(prev => prev.filter(item => item.id !== id));
    const actualizarCantidad = (id, cambio) => {
        setCarro(prev => prev.map(item => {
            if (item.id === id) {
                const nueva = item.cantidad + cambio;
                return nueva > 0 ? { ...item, cantidad: nueva } : item;
            }
            return item;
        }));
    };



    const styles = {
        overlay: {
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 99998,
            opacity: mostrar ? 1 : 0, visibility: mostrar ? 'visible' : 'hidden', transition: 'all 0.3s'
        },
        panel: {
            position: modoFijo ? 'relative' : 'fixed',  // ← relative en modo fijo
            top: modoFijo ? undefined : 0,
            right: modoFijo ? undefined : 0,
            bottom: modoFijo ? undefined : 0,
            left: modoFijo ? undefined : 0,
            minHeight: 0,        // ← AGREGAR ESTO
            width: '100%',
            height: '100%',    // ← el padre ya tiene height: 100%, esto lo respeta
            backgroundColor: '#fff',
            zIndex: modoFijo ? 1 : 99999,
            transform: modoFijo ? 'none' : (mostrar ? 'translateX(0)' : 'translateX(100%)'),
            transition: 'transform 0.3s ease-out',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }
    };

    const renderVariantesSmart = (detalles) => {
        if (!detalles) return null;

        // 1. Separar por grupos (vienen separados por " | ")
        const lineas = detalles.split('|');
        const grupos = {};

        lineas.forEach(linea => {
            // Extraemos el nombre del grupo: [NOMBRE_GRUPO]: contenido
            const match = linea.match(/\[(.+?)\]/);
            const tag = match ? match[1].trim() : "OTROS";
            
            // Extraemos el contenido después de "]: "
            let contenido = linea.replace(/\[.*?\]:\s*/g, '').trim();
            
            // Limpiamos "SIN:" y "EXTRA:" para que se vea más ordenado
            contenido = contenido.replace(/^SIN:\s*/i, '🚫 Sin ').replace(/^EXTRA:\s*/i, '➕ ');
            
            if (!grupos[tag]) grupos[tag] = [];
            if (contenido) grupos[tag].push(contenido);
        });

        // 2. Renderizamos cada grupo con colores según el tipo
        const colores = ['#0d6efd', '#198754', '#dc3545', '#fd7e14', '#6f42c1', '#20c997', '#e83e8c'];
        let colorIdx = 0;

        return (
            <div className="mt-1 d-flex flex-column gap-1">
                {Object.keys(grupos).map((tag, idx) => {
                    const color = colores[colorIdx % colores.length];
                    colorIdx++;
                    return (
                        <div key={idx} className="p-1 rounded border-left" style={{
                            backgroundColor: `${color}10`,
                            borderLeft: `3px solid ${color}`,
                            fontSize: '0.7rem'
                        }}>
                            <div className="d-flex align-items-center">
                                <span className="badge mr-1 text-white" style={{ 
                                    fontSize: '0.6rem', 
                                    backgroundColor: color,
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {tag.length > 12 ? tag.substring(0, 12) + '…' : tag}
                                </span>
                                <span className="text-dark font-weight-bold ml-1" style={{ lineHeight: '1.2' }}>
                                    {grupos[tag].join(' • ')}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <>
            <style>{`
                .order-type-switch {
                    display: flex;
                    gap: 6px;
                }
                .type-switch-btn {
                    display: flex;
                    align-items: center;
                    padding: 4px 10px;
                    border-radius: 20px;
                    border: 1px solid #f1f3f5;
                    background: #f8f9fa;
                    color: #adb5bd;
                    cursor: pointer;
                    font-size: 0.75rem;
                    font-weight: 700;
                    text-transform: uppercase;
                    transition: all 0.2s;
                }
                .type-switch-btn i { font-size: 0.8rem; }

                .type-switch-btn.active-local { border-color: #0d6efd; background: #e7f1ff; color: #0d6efd; }
                .type-switch-btn.active-tel { border-color: #0dcaf0; background: #e0f7fa; color: #0dcaf0; }
                
                .btn-checkout {
                    height: 56px;
                    border-radius: 15px !important;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    line-height: 1;
                    box-shadow: 0 4px 15px rgba(40, 167, 69, 0.2);
                }
                .btn-checkout .btn-label { font-size: 0.8rem; opacity: 0.9; margin-bottom: 4px; text-transform: uppercase; letter-spacing: 1px; }
                .btn-checkout .btn-amount { font-size: 1.4rem; font-weight: 900; }
            `}</style>

            {mostrar && !modoFijo && <div style={styles.overlay} onClick={toggleCarro}></div>}

            <div style={styles.panel}>
                <div className="d-flex justify-content-between align-items-center px-3 py-1 border-bottom bg-white" style={{ flexShrink: 0 }}>
                    <div className="d-flex align-items-center">
                        {/* 🚩 Botón cerrar (siempre visible, especialmente en móvil) */}
                        <button className="btn btn-sm text-muted mr-2" onClick={toggleCarro} style={{ width: '22px', height: '22px', padding: 0, border: 'none' }}>
                            <i className="fas fa-chevron-down" style={{ fontSize: '0.7rem' }}></i>
                        </button>
                        <span className="small text-muted font-weight-bold text-uppercase" style={{ letterSpacing: '0.5px' }}>Mi Pedido</span>
                    </div>
                    <button className="btn btn-sm text-muted" onClick={() => setCarro([])} title="Vaciar carrito" style={{ width: '22px', height: '22px', padding: 0, border: 'none' }}>
                        <i className="fas fa-trash-alt" style={{ fontSize: '0.7rem' }}></i>
                    </button>
                </div>

                <div className="flex-grow-1 overflow-auto p-2 bg-light" style={{ minHeight: 0 }}>
                    {carro.length === 0 ?
                        <div className="text-center text-muted mt-5">
                            <i className="fas fa-shopping-basket fa-3x mb-3 opacity-20"></i>
                            <p>Carrito vacío</p>
                        </div> :
                        carro.map((item) => (
                            <div key={item.id} className="card mb-1 shadow-sm border-0">
                                <div className="card-body p-2">
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div style={{ maxWidth: '75%' }}>
                                            <h6 className="mb-0 font-weight-bold text-dark" style={{ fontSize: '0.9rem' }}>{item.nombre}</h6>

                                            {/* 🔥 AQUÍ LLAMAMOS A LA FUNCIÓN QUE LIMPIA EL TEXTO Y PERMITE EDITAR 🔥 */}
                                            <div
                                                className="cursor-pointer"
                                                onClick={() => onPersonalizarItem(item)}
                                                title="Click para editar ingredientes"
                                            >
                                                {renderVariantesSmart(item.variantes_detalles)}
                                            </div>
                                        </div>
                                        <span className="font-weight-bold text-dark" style={{ whiteSpace: 'nowrap', fontSize: '0.85rem' }}>
                                            ${fmt(Math.round(Number(item.precio || item.valor) * item.cantidad))}
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mt-1">
                                        <div className="btn-group">
                                            <button className="btn btn-sm btn-outline-secondary px-3 py-0" onClick={() => actualizarCantidad(item.id, -1)}>-</button>
                                            <span className="btn btn-sm btn-light disabled font-weight-bold py-0">
                                                {Number.isInteger(item.cantidad) ? item.cantidad : item.cantidad.toFixed(3)}
                                            </span>
                                            <button
                                                className="btn btn-sm btn-outline-secondary px-3 py-0"
                                                onClick={() => actualizarCantidad(item.id, 1)}
                                            >
                                                +
                                            </button>
                                        </div>
                                        <button className="btn btn-sm text-muted py-0" onClick={() => eliminarDelCarro(item.id)}>
                                            <i className="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>

                <div className="p-3 bg-white border-top" style={{ flexShrink: 0 }}>
                    {/* SELECTOR DE TIPO DE PEDIDO COMPACTO (una sola línea) */}
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <label className="small text-muted font-weight-bold uppercase mb-0">Tipo:</label>
                        <div className="order-type-switch">
                            <button
                                type="button"
                                className={`type-switch-btn ${tipoVenta === 'USUARIO_PRESENCIAL' ? 'active-local' : ''}`}
                                onClick={() => setTipoVenta('USUARIO_PRESENCIAL')}
                            >
                                <i className="fas fa-utensils mr-1"></i>Local
                            </button>
                            <button
                                type="button"
                                className={`type-switch-btn ${tipoVenta.indexOf('TELEFONO') !== -1 ? 'active-tel' : ''}`}
                                onClick={() => setTipoVenta('TELEFONO_RETIRO')}
                            >
                                <i className="fas fa-motorcycle mr-1"></i>Pedido
                            </button>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between small mb-1">
                        <span className="text-muted">Subtotal:</span>
                        <span className="text-dark">${fmt(subtotal)}</span>
                    </div>

                    {descuentoGlobal > 0 && (
                        <div className="d-flex justify-content-between small mb-1 text-success font-weight-bold">
                            <span>Dcto ({descuentoGlobal}%):</span>
                            <span>-${fmt(ahorro)}</span>
                        </div>
                    )}

                    {/* BOTÓN COBRAR NIVEL DIOS */}
                    <button
                        className="btn btn-success btn-checkout btn-block mt-2"
                        disabled={carro.length === 0}
                        onClick={() => confirmarCompra(totalFinal)}
                    >
                        <span className="btn-label">
                            {tipoVenta === 'EXTRA_APPS' ? 'Seleccionar App' : 'Confirmar y Cobrar'}
                        </span>
                        <span className="btn-amount">
                            ${fmt(totalFinal)}
                        </span>
                    </button>
                </div>
            </div>
        </>
    );
}
export default CarritoLateral;